var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-box"},[_c('div',{staticClass:"error-flex"},[_c('img',{staticClass:"error-img",attrs:{"src":require("@/assets/images/404.png"),"background-size":"cover"}}),_c('p',[_vm._v(_vm._s(_vm.markedWords))])])])}
var staticRenderFns = []

export { render, staticRenderFns }